import Person from '@mui/icons-material/Person'
import RosterItemViewer from 'src/supportPortal/views/roster/component/viewers/RosterItemViewer'

export default function MyCurrentRosterSlotViewer({ ...rest }) {
  return (
    <RosterItemViewer
      {...rest}
      disableSlotApiSignature="/api/secure/teacher/clinic-roster/disable"
      sidebarIcon={<Person />}
    />
  )
}
